export const lastUpdated = (value?: string, t?: (key: string, options?: any) => string) => {
    if (!value) return "";
    const target = new Date(value);
    const now = new Date();
    const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate()).getTime();
    const startOfTarget = new Date(target.getFullYear(), target.getMonth(), target.getDate()).getTime();
    const diffDays = Math.floor((startOfToday - startOfTarget) / (1000 * 60 * 60 * 24));

    if (!t) {
        // Fallback to English if no translation function
        if (diffDays <= 0) return "Today";
        if (diffDays === 1) return "Yesterday";
        if (diffDays <= 7) return `${diffDays} days ago`;
    } else {
        if (diffDays <= 0) return t('date.today');
        if (diffDays === 1) return t('date.yesterday');
        if (diffDays <= 7) return t('date.daysAgo', { days: diffDays });
    }

    const month = `${target.getMonth() + 1}`.padStart(2, "0");
    return `${target.getFullYear()}-${month}`;
}